/* eslint-disable */
import React from 'react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getOrderAction } from '../Selectors'
import { VNORDERS_ACTIONS } from '../Enums'
import { useVNOrders } from '../hooks/useVNOrders'

const VNOrders = () => {
  const orderAction = useSelector(getOrderAction)

  const { startOrder } = useVNOrders()

  useEffect(() => {
    console.log('orderAction has changed:', orderAction.toJS())

    switch (orderAction.get('action')) {
      case VNORDERS_ACTIONS.START_ORDER:
        startOrder(orderAction.get('params'))
        break
      case VNORDERS_ACTIONS.TOTAL_ORDER:
        break
    }
  }, [orderAction])

  return <></>
}

export default VNOrders
